module.exports = __webpack_public_path__ + "img/1920_stores_img8.2c48fe42.png";